import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { i18n, getLocale } from 'core/i18n';
import Tools from 'core/tools';
import InputField from 'components/inputField/index';
import Button from 'components/button/index';
import Dialog from 'components/dialog/index';

import './login.css';

import {
  login,
  forgotMima,
  closeSuccesDailog,
  openForgotMimaDailog,
  closeForgotMimaDailog
} from './action';

class LoginIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      skyAgentName: '',
      skyAgentPw: '',
      forgetPW_skyAgentName: ''
    };
  }

  componentDidMount() {
    console.log('LoginIndex', this.props);
    // 當有登入時導至首頁
    if (sessionStorage.getItem('user')) { 
      let url = Tools.generateLocaleUrl(getLocale(), '/Home')
      this.props.history.push(url);
    }
  }

  render() {
    const self = this,
      {
        state: _state,
        props
      } = self,
      {
        state,
        dispatch = () => { }
      } = props,
      {
        errors,
        showForgotMimaDialog,
        showResultDialog
      } = state,
      {
        skyAgentName,
        skyAgentPw,
        forgetPW_skyAgentName
      } = _state;
    
    return (
      <div className='login-frame'>
        {/* 背景圖 */}
        <img className='login-bg left-top' alt='' src={require('assets/images/bg-img-1.svg')} />
        <img className='login-bg right-bottom' alt='' src={require('assets/images/bg-img-2.svg')} />
        <img className='login-bg flight' alt='' src={require('assets/images/bg-img-4.svg')} />
        {/* 登入區塊 */}
        <div className='login-panel'>
          <div className='login-panel-title'>
            Welcome,
            <br /> Tigerair B2B System
          </div>
          <div className='login-panel-tip'>{i18n('login_title')}</div>
          <div className='login-panel-input-field'>
            <InputField
              placeholder={i18n('placeholder_user_name')}
              onBlurActEvent={(data) => {
                this.setState({
                  skyAgentName: data
                });
              }}
              value={skyAgentName}
              validateMessage={errors && errors.agentName ? i18n('error_login_user_name') : null}
            />
            <InputField
              type={'password'}
              inputType={'password'}
              placeholder={i18n('placeholder_password')}
              onBlurActEvent={(data) => {
                this.setState({
                  skyAgentPw: data
                });
              }}
              value={skyAgentPw}
              validateMessage={errors && errors.password ? i18n('error_login_password') : null}
            />
          </div>
          <Button
            className={'primary-button login-panel-button'}
            onClick={() => {
              let requestData = {
                agentName: skyAgentName,
                password: skyAgentPw
              };
              dispatch(login(requestData, this.props));
            }}
          >
            {i18n('login')}
          </Button>
          <div className='login-panel-forgot'>
            <span
              onClick={() => {
                dispatch(openForgotMimaDailog())
              }}
            >
              {`${i18n('forget_password')} ?`}
            </span>
          </div>
        </div>
        {/* 忘記密碼 dialog */}
        <Dialog
          dialogId='login-forget-pw-dialog'
          maxWidth='md'
          zIndex={2000}
          open={!!showForgotMimaDialog}
          onClose={() => {
            dispatch(closeForgotMimaDailog())
          }}
          title={i18n('forget_password')}
          actionsClassName='login-forget-pw-dialog'
          actions={[
            <Button
              className={'primary-button login-panel-button'}
              onClick={() => {
                // 打重設密碼 mail
                let validData = {
                  forgetPW_skyAgentName: forgetPW_skyAgentName,
                }
                dispatch(forgotMima(validData),
                  //送出後清除state
                  self.setState({
                    forgetPW_skyAgentName: ''
                  })
                )
              }}
            >
              {i18n('submit')}
            </Button>
          ]}
        >
          <div className='login-forget-pw-dialog-body'>
            <div className='body-title'>{i18n('sky_agent_account')}</div>
            <InputField
              className='login-agent-id'
              placeholder={i18n('placeholder_user_name')}
              onBlurActEvent={(data) => {
                self.setState({
                  forgetPW_skyAgentName: data
                });
              }}
              value={forgetPW_skyAgentName}
              validateMessage={errors && errors.forgetPW_skyAgentName ? i18n('error_login_user_name') : null}
            />
          </div>
        </Dialog>
        {/* 忘記密碼發送成功 dialog */}
        <Dialog
          dialogId='login-forget-pw-dialog'
          maxWidth='md'
          zIndex={2000}
          open={!!showResultDialog}
          onClose={() => {
            dispatch(closeSuccesDailog());
          }}
          title={i18n('forget_password')}
          actionsClassName='login-forget-pw-dialog'
          actions={[
            <Button
              className={'primary-button login-panel-button'}
              onClick={() => {
                dispatch(closeSuccesDailog());
              }}
            >
              {i18n('confirm')}
            </Button>
          ]}
        >
          <div className='login-forget-pw-dialog-body'>
            <div className='body-title'>{i18n('success_post_change_password_mail')}</div>
          </div>
        </Dialog>
      </div>
    );
  }
}

let mapStateToProps = state => {
  return {
    state: state.loginReducer
  };
};

export default connect(mapStateToProps)(withRouter(LoginIndex));
